/** Ключ для Map / сравнение id сообщения (API отдаёт string). */
export function messageIdKey(id: string | number): string {
  return String(id);
}

export function compareMessageId(a: string | number, b: string | number): number {
  const sa = messageIdKey(a);
  const sb = messageIdKey(b);
  const na = Number(sa);
  const nb = Number(sb);
  if (Number.isSafeInteger(na) && Number.isSafeInteger(nb)) {
    return na - nb;
  }
  return sa < sb ? -1 : sa > sb ? 1 : 0;
}

/** Парсинг ISO-даты Telegram для сортировки (мс с эпохи). */
export function parseFeedDate(date: string): number {
  if (!date) return 0;
  const ms = Date.parse(date);
  return Number.isFinite(ms) ? ms : 0;
}

/**
 * Хронология ленты: строго по date (последнее в чате — внизу), без приоритета «своих» live.
 * У live id отрицательные и убывают (-1, -2, …) — при равной дате порядок по id инвертирован.
 */
export function compareFeedCursor(
  a: { date: string; id: string | number; is_live?: boolean },
  b: { date: string; id: string | number; is_live?: boolean },
): number {
  const da = parseFeedDate(a.date);
  const db = parseFeedDate(b.date);
  if (da !== db) return da - db;
  if (a.is_live && b.is_live) {
    return compareMessageId(b.id, a.id);
  }
  return compareMessageId(a.id, b.id);
}
